export const screenSize = {
    size_s: "1070px",
    size_m: "1280px",
    size_xl: "1440px",
    size_2xl: "1536px",
    size_3xl: "1920px",
}